//@ts-nocheck
import {
  Divider,
  Dropdown,
  Button,
  Form,
  Grid,
  Input,
  Text,
  Popup,
  TextArea,
  DatePickerInput,
  DatePicker,
  Tab,
} from '@wework/dieter-ui'
import React, { useCallback, useEffect, useState } from 'react'
import { useSidebar } from '../../hoc/withSidebar'
import { Lock } from '../Icons'
import EditPhysicalSpaceMeetingRoom from './EditPhysicalSpaceMeetingRoom'
import EditPhysicalSpaceOffice from './EditPhysicalSpaceOffice'
import ArchiveModal from './ArchiveModal'
import EditHistory from './EditHistory'

export default function EditProductMeetingRoomAttributes({
  space,
  roomData,
  setRoomData,
}) {
  const [showArchive, setShowArchive] = useState(false)

  if (showArchive) {
    return (
      <ArchiveModal
        space={space}
        open={true}
        onClose={() => {
          setShowArchive(false)
        }}
      />
    )
  }

  if (!roomData) {
    return null
  }
  return (
    <>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <Text size="small" style={{ fontWeight: 'bold', fontSize: 16 }}>
              Notes
            </Text>
            <Text size="small" style={{ color: '#777' }}>
              Add notes or special instructions for the room. This will be
              visible to members.{' '}
            </Text>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              label="Notes"
              control={TextArea}
              size="small"
              value="This is great for large events."
              outline
              className="noOpacity"
              style={{ marginBottom: 24 }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <div>
              <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                Open / closed dates
              </Text>
              <Text size="small" style={{ color: '#777' }}>
                Set dates for when a room is first opened or closed.{' '}
              </Text>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Group widths="equal">
              <Form.Field
                size="mini"
                value="20 Dec 2021"
                placeholder="Opened date"
                className="dateInputWrapper modDatePicker"
                keepFocus={true}
                control={DatePickerInput}
                inputProps={{
                  className: 'modDatePicker',
                }}
              />
              <Form.Field
                size="small"
                value=""
                placeholder={'Closed date'}
                className="dateInputWrapper modDatePicker"
                keepFocus={true}
                control={DatePickerInput}
                inputProps={{
                  className: 'modDatePicker',
                  style: {
                    marginLeft: '5px',
                  },
                }}
              />
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <div>
              <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                Archive this product
              </Text>
              <Text size="small" style={{ color: '#777' }}>
                Once archived, the product will no longer be available. You can
                unarchive it later to make it available again.{' '}
              </Text>
            </div>
          </Grid.Column>
          <Grid.Column
            width={8}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              basic
              color="red"
              size="small"
              variant="contained"
              onClick={() => setShowArchive(true)}
            >
              Archive
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}
